import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import { getValidChildren } from '@wp-g2/utils';
import React from 'react';
import { ControlGroupContext } from './ControlGroup.Context';
import * as styles from './ControlGroup.styles';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./types').Props, 'div'>} props
 */

export function useControlGroup(props) {
  var _useContextSystem = useContextSystem(props, 'ControlGroup'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      _useContextSystem$dir = _useContextSystem.direction,
      direction = _useContextSystem$dir === void 0 ? 'row' : _useContextSystem$dir,
      templateColumns = _useContextSystem.templateColumns,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className", "direction", "templateColumns"]);

  var validChildren = getValidChildren(children);
  var isVertical = direction === 'column';
  var classes = cx(styles.itemFocus, !!templateColumns && styles.itemGrid, className);
  var clonedChildren = validChildren && validChildren.map(function (child, index) {
    var isFirst = index === 0;
    var isLast = index + 1 === validChildren.length;
    var isMiddle = !isFirst && !isLast; // @ts-ignore

    var _key = (child == null ? void 0 : child.key) || index;

    var contextStyles = cx(isFirst ? isVertical ? styles.firstRow : styles.first : undefined, isMiddle && styles.middle, isLast ? isVertical ? styles.lastRow : styles.last : undefined);
    return /*#__PURE__*/React.createElement(ControlGroupContext.Provider, {
      key: _key,
      value: {
        isFirst: isFirst,
        isLast: isLast,
        isMiddle: isMiddle,
        isOnly: isFirst && isLast,
        isVertical: isVertical,
        styles: contextStyles
      }
    }, child);
  });
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    children: clonedChildren,
    className: classes,
    direction: direction,
    templateColumns: templateColumns
  });
}